(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const OPEN_CLASS = 'hn-hover-panel--is-open';
    const FORCE_HIDE_CLASS = 'hn-hover-panel--force-hide';
    const CLOSE_DELAY_MS = 180;
    let closeTimer;

    const setupHoverPanel = () => {
      const headerWrapper = document.querySelector('.header-wrapper');
      if (!headerWrapper) return;

      const panel = headerWrapper.querySelector('.hn-hover-panel');
      const triggerItem = headerWrapper.querySelector(
        '.header__inline-menu [data-hover-panel-trigger], .header__inline-menu #HeaderMenu-all-ingredients, .header__inline-menu #HeaderMenu-all-materials, .header__inline-menu a[href*="/collections/all-ingredients"], .header__inline-menu a[href*="/collections/all-materials"]'
      );
      if (!panel || !triggerItem) return;

      const menuCollator = new Intl.Collator(document.documentElement.lang || 'en', {
        sensitivity: 'base',
      });

      panel.querySelectorAll('[data-alphabetical-menu]').forEach((list) => {
        const items = Array.from(list.children);
        items
          .sort((firstItem, secondItem) =>
            menuCollator.compare(firstItem.textContent.trim(), secondItem.textContent.trim())
          )
          .forEach((item) => list.appendChild(item));
      });

      const clearCloseTimer = () => {
        if (!closeTimer) return;
        window.clearTimeout(closeTimer);
        closeTimer = null;
      };

      const openPanel = () => {
        if (!desktopQuery.matches) return;
        clearCloseTimer();
        headerWrapper.classList.remove(FORCE_HIDE_CLASS);
        headerWrapper.classList.add(OPEN_CLASS);
      };

      const closePanel = () => {
        clearCloseTimer();
        headerWrapper.classList.remove(OPEN_CLASS);
        headerWrapper.classList.remove(FORCE_HIDE_CLASS);
      };

      const scheduleClosePanel = () => {
        clearCloseTimer();
        closeTimer = window.setTimeout(() => {
          headerWrapper.classList.remove(OPEN_CLASS);
        }, CLOSE_DELAY_MS);
      };

      triggerItem.addEventListener('mouseenter', openPanel);
      triggerItem.addEventListener('focusin', openPanel);
      triggerItem.addEventListener('mouseleave', scheduleClosePanel);

      panel.addEventListener('mouseenter', openPanel);
      panel.addEventListener('focusin', openPanel);
      panel.addEventListener('mouseleave', scheduleClosePanel);

      headerWrapper.addEventListener('mouseleave', closePanel);

      headerWrapper
        .querySelectorAll('.header__inline-menu .list-menu--inline > li')
        .forEach((menuItem) => {
          if (
            menuItem.matches('[data-hover-panel-trigger]') ||
            menuItem.querySelector('#HeaderMenu-all-ingredients, #HeaderMenu-all-materials, a[href*="/collections/all-ingredients"], a[href*="/collections/all-materials"], [data-hover-panel-trigger]')
          ) {
            return;
          }

          menuItem.addEventListener('mouseenter', closePanel);
          menuItem.addEventListener('focusin', closePanel);
        });

      headerWrapper
        .querySelectorAll('.header__icons.hn-nav__icons, details-modal.hn-nav__search-details')
        .forEach((closeTarget) => {
          closeTarget.addEventListener('mouseenter', closePanel);
          closeTarget.addEventListener('focusin', closePanel);
        });

      desktopQuery.addEventListener('change', (event) => {
        if (!event.matches) {
          closePanel();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupHoverPanel, { once: true });
    } else {
      setupHoverPanel();
    }
  })();

  document.addEventListener('click', (event) => {
    const clickedLink = event.target.closest('.header-wrapper .header__inline-menu a, .header-wrapper .hn-hover-panel a');
    if (!clickedLink) return;

    const headerWrapper = clickedLink.closest('.header-wrapper');
    if (!headerWrapper) return;

    const hidePanel = () => {
      headerWrapper.classList.remove('hn-hover-panel--is-open');
      headerWrapper.classList.remove('hn-hover-panel--force-hide');
    };

    headerWrapper.classList.add('hn-hover-panel--force-hide');

    if (!headerWrapper.matches(':hover')) {
      hidePanel();
      return;
    }

    headerWrapper.addEventListener('mouseleave', hidePanel, { once: true });
  });

  } catch(e) { console.error(e); }
})();
})();
